import styled from "styled-components";

export const StyledEmptyCart = styled.div`
  width: 100%;
  max-width: 1125px;
  text-align: center;
  margin: auto;
`;

export const StyledTitle = styled.div`
  padding: 35px 0;
`;

export const StyledContent = styled.div`
  width: 100%;
  min-height: 245px;
`;

export const StyledMsg = styled.div`
  margin: 15px 20px 20px;
  line-height: 1.4;
`;

export const StyledButtonWrapper = styled.div`
  width: 160px;
  margin: auto;
`;
